<template>
    <div>
 <v-alert
      :value="alert"
      :color="alertColor"
      dark
      border="top"
      icon="mdi-home"
      transition="scale-transition"
    >
      {{alertMsg}}

     
    </v-alert>


        <v-card flat class="grey lighten-4">
           
            <v-textarea v-model="fm.message" name="txtmessage" solo label="Enter Message" ></v-textarea>

           <v-card-text class="mt-n4">MESSAGE TYPES</v-card-text>
           <div class="pa-5"  >

        <v-card-text class="mt-n8" >
           

        <v-checkbox  v-for="c in alertTypes" v-model="fm.ops" :key="c.key" justify="space-around" :label="c.name" :value="c.name" name="opts"  hide-details></v-checkbox>
          
                  
           
        </v-card-text> 
        </div>
        <v-card-actions>
            
            <div class="flex-grow-1"></div>
            <v-btn v-if="fm.ops.length>0 && fm.message.length" block class="success " @click="sendMessage">Send Message</v-btn>
        </v-card-actions>
        </v-card>
    </div>
</template>
<script>
import fb from '../store/firebase.js';
export default {
    data(){
        return{
            alert:false,
            alertColor:"blue",
            alertMsg: 'Message Send',
           fm:{
               message:"",
               ops: []
           },
           alertTypes:[],
        }
    },
    computed:{
        
    },
    methods:{
        sendMessage(){
            
            let ob = {
                created: new Date(),
                ...this.fm
            };
             ob.ops = this.fm.ops.reduce( (acc, itm)=>{
                 acc[itm] = true;
                 return acc
             }, {} )
           
           this.$store.dispatch('addAlert', ob);
           this.fm.message = "";
          // this.fm.ops.length = 0;
           this.$timer.start("setAlertMsgSend");
           this.$timer.start("setAlertErr");
        //    this.$router.push("/");
        },
        setAlertMsgSend(){
            this.alertColor = 'blue';
            this.alertMsg = "Message Alert Sent!";
            this.alert = true;
        },
        setAlertErr(){
            this.alert = false;
        },
    },
    timers:{
        setAlertErr:{time:2500, autostart:false  },
        setAlertMsgSend:{time:500, autostart:false},
    },
    mounted(){
       this.alertTypes = this.$store.getters.AlertTypes;
    }
}
</script>